import React from "react";
import { useNavigate } from "react-router-dom";
import heroBg from "../assets/YTDown_Shorts_Solar-panel-cleaning-in-2025_Media_Ojjn-yEeYpA_001_1080p.mp4";

function Home({ t }) {
  const navigate = useNavigate();

  const goTo = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        <div className="hero__video-bg">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="hero__video"
          >
            <source src={heroBg} type="video/mp4" />
          </video>
          <div className="hero__video-overlay" />
        </div>
        <div className="hero__bg-shapes">
          <div className="shape shape--1" />
          <div className="shape shape--2" />
          <div className="shape shape--3" />
        </div>
        <div className="hero__content">
          <span className="hero__badge">{t.hero.badge}</span>
          <h1 className="hero__title">{t.hero.title}</h1>
          <p className="hero__subtitle">{t.hero.subtitle}</p>
          <div className="hero__actions">
            <button className="btn btn--primary" onClick={() => goTo("/contact")}>
              {t.hero.cta}
            </button>
            <button
              className="btn btn--ghost"
              onClick={() =>
                document.getElementById("services").scrollIntoView({ behavior: "smooth" })
              }
            >
              {t.hero.secondary}
            </button>
          </div>
        </div>
        <div className="hero__visual">
          <div className="panel-card">
<div className="panel-card__grid">
              {[...Array(9)].map((_, i) => (
                <div key={i} className={`panel-cell ${i % 3 === 1 ? "panel-cell--bright" : ""}`} />
              ))}
            </div>
            <div className="panel-card__label">+25% Output</div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="stats">
        <div className="container">
          {t.stats.map((s, i) => (
            <div className="stat-card" key={i}>
              <div className="stat-card__value">{s.value}</div>
              <div className="stat-card__label">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Problem Section */}
      <section className="problem">
        <div className="container container--narrow">
<h2 className="section-title">{t.problem.title}</h2>
          <p className="problem__text">{t.problem.text}</p>
        </div>
      </section>

      {/* Services */}
      <section className="services" id="services">
        <div className="container">
          <div className="services__header">
            <h2 className="section-title">{t.services.title}</h2>
            <p className="section-subtitle">{t.services.subtitle}</p>
          </div>
          <div className="services__list">
            {t.services.items.map((svc, i) => (
              <div className="service-row" key={i}>
                <div className="service-row__num">0{i + 1}</div>
                <div className="service-row__divider" />
                <div className="service-row__body">
                  <h3 className="service-row__title">{svc.title}</h3>
                  <p className="service-row__desc">{svc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Us */}
      <section className="why">
        <div className="container">
          <h2 className="section-title">{t.why.title}</h2>
          <p className="section-subtitle">{t.why.subtitle}</p>
          <div className="why__grid">
            {t.why.items.map((item, i) => (
              <div className="why-card" key={i}>
                <div className="why-card__icon">{item.icon}</div>
                <h3 className="why-card__title">{item.title}</h3>
                <p className="why-card__desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Who We Work With */}
      <section className="targets">
        <div className="container">
          <h2 className="section-title">{t.targets.title}</h2>
          <div className="targets__grid">
            {t.targets.items.map((item, i) => (
              <div className="target-chip" key={i}>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
          <p className="targets__pitch">{t.targets.pitch}</p>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="cta-banner">
        <div className="container container--narrow cta-banner__inner">
          <h2 className="cta-banner__title">{t.cta.title}</h2>
          <p className="cta-banner__subtitle">{t.cta.subtitle}</p>
          <button className="btn btn--primary btn--lg" onClick={() => goTo("/contact")}>
            {t.cta.button}
          </button>
        </div>
      </section>
    </div>
  );
}

export default Home;
